import {
  alignRollingScheduleVisibleStartToNow,
  getCurrentHourSAST,
  getDateStrSAST,
  getTodayStrSAST,
} from '@/lib/sastTime';

export type ResourceScheduleTimelineMode = 'dynamic' | 'static';

export function clampResourceScheduleVisibleStartHour(hour: number): number {
  const safeHour = Number.isFinite(hour) ? hour : 0;
  return Math.max(-12, Math.min(23, safeHour));
}

export function getDefaultResourceScheduleVisibleStartHour(configStartHour: number): number {
  return clampResourceScheduleVisibleStartHour(configStartHour);
}

interface ResolveResourceScheduleAutoVisibleStartHourOptions {
  timelineMode: ResourceScheduleTimelineMode;
  selectedDate: Date;
  defaultVisibleStartHour: number;
  visibleHoursCount: number;
  currentHourSast?: number;
  todayDateKey?: string;
}

export function resolveResourceScheduleAutoVisibleStartHour({
  timelineMode,
  selectedDate,
  defaultVisibleStartHour,
  visibleHoursCount,
  currentHourSast = getCurrentHourSAST(),
  todayDateKey = getTodayStrSAST(),
}: ResolveResourceScheduleAutoVisibleStartHourOptions): number {
  const clampedDefaultVisibleStartHour = clampResourceScheduleVisibleStartHour(defaultVisibleStartHour);

  if (timelineMode === 'static') {
    return clampedDefaultVisibleStartHour;
  }

  if (getDateStrSAST(selectedDate) === todayDateKey) {
    return alignRollingScheduleVisibleStartToNow(currentHourSast, visibleHoursCount);
  }

  return clampedDefaultVisibleStartHour;
}